import React, { Component } from 'react';
import { routerActions } from 'connected-react-router';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {Header, Form, Grid, Button, Table, Message, TextArea, Segment} from 'semantic-ui-react'
import DatePicker from '../../components/DatePicker';
import * as Facility from '../../store/Facility';
import * as Events from '../../store/Events';
import * as Venue from '../../store/Venue';
import InventoryBlock from '../../components/InventoryBlock';
import * as geo from '../../helpers/geo';
import Editor from '../../components/WysiwygEditor';

const distanceOptions = [
    {text: "< .1 mi.", value: .1},
    {text: "< .25 mi.", value: .25},
    {text: "< .5 mi.", value: .5},
    {text: "< 1 mi.", value: 1},
    {text: "< 5 mi.", value: 5},
]

const emailFields = ["parkerName",
"facilityName",
"facilityAddress",
"facilityCity",
"facilityState",
"facilityZip",
"eventName",
"eventAddress",
"eventCity",
"eventState",
"eventSlug",
"reservationNumber",
"reservationBlocks",
"reservationSpots",
"reservationTotal",
"reservationModificationDate",
"eventDirections",
"walkingDirections",
"staffFirstName",
"staffLastName",
"staffTitle",
"staffEmail",
"staffPhone"];

const defaultEmailTemplate = "<p>{{facilityName}}</p>\n" +
"<p></p>\n" +
"<p><a href='http://maps.google.com/?q={{encodedfacilityAddress}},+{{encodedfacilityCity}},+{{encodedfacilityState}}+{{encodedfacilityZip}}'>{{facilityAddress}}</a></p>\n" +
"<p><a href='http://maps.google.com/?q={{encodedfacilityAddress}},+{{encodedfacilityCity}},+{{encodedfacilityState}}+{{encodedfacilityZip}}'>{{facilityCity}}, {{facilityState}} {{facilityZip}}</a></p>\n" +
"<p></p>\n" +
"<p></p>\n" +
"<p>{{parkerName}},</p>\n" +
"<p></p>\n" +
"<p>Thank you for your parking reservation for the {{eventName}} event in {{eventCity}}, {{eventState}}. Below you will find your parking reservation information. </p>\n" +
"<p style='padding-left: 30px;'><strong>Reservation Number:</strong> <a href='https://reservations.denisonparking.com/{{eventSlug}}/{{reservationNumber}}/confirmation'>{{reservationNumber}}</a></p>\n" +
"<p style='padding-left: 30px;'><strong>Reservation Information:</strong> {{reservationBlocks}}</p>\n" +
"<p style='padding-left: 30px;'><strong>Parking spot quantity reserved:</strong> {{reservationSpots}}</p>\n" +
"<p style='padding-left: 30px;'><strong>Total charged:</strong> {{reservationTotal}}</p>\n" +
"<p>To update or cancel this reservation, please contact the garage manager. Parking requests can be modified up to {{reservationModificationDate}}. If you have questions, please visit our <a href='https://s3.us-east-2.amazonaws.com/denisonparking-static/FAQ.pdf'>FAQ page</a>.</p>\n" +
"<p></p>\n" +
"<p></p>\n" +
"<p><strong>What to do upon arrival:</strong></p>\n" +
"<p>{{eventDirections}}</p>\n" +
"<p></p>\n" +
"<p></p>\n" +
"<p><strong>Walking directions from the facility to the event:</strong></p>\n" +
"<p>{{walkingDirections}}</p>\n" +
"<p></p>\n" +
"<p></p>\n" +
"<p>{{staffFirstName}} {{staffLastName}}</p>\n" +
"<p>{{staffTitle}}</p>\n" +
"<p>{{facilityName}}</p>\n" +
"<p>E. {{staffEmail}}</p>\n" +
"<p>P. {{staffPhone}}</p>";

class CreateEvent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            distanceFilter: .1,
            emailTemplate: defaultEmailTemplate,
        }
        this.onGarageSelected = this.onGarageSelected.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onAddBlock = this.onAddBlock.bind(this);
        this.onBlockChange = this.onBlockChange.bind(this);
        this.onDistanceChange = this.onDistanceChange.bind(this);
        this.filter = this.filter.bind(this);
        this.onEditorChange = this.onEditorChange.bind(this);
    }
    
    onChange(e, {name, value}){
        const {event, actions} = this.props;
        let newProps = {[name]:value};
        if (name === 'name') {
            newProps = {...newProps, 'slug': value.replace(/ /g, '').toLowerCase()};
        }
        actions.updateNewEvent({...event, ...newProps});
    }

    onDistanceChange(e, {name, value}){
        console.log(value);
        this.setState({distanceFilter: value});
    }

    onAddBlock(e) {
        const {actions, event} = this.props;
        e.preventDefault();
        actions.addNewBlock(event);
    }

    onBlockChange(e, block) {
        const {actions, event} = this.props;
        actions.updateNewBlock(event, block);
    }

    async onSubmit(e) {
        const {event, actions} = this.props;
        const {emailTemplate} = this.state;
        try {
            const {blocks} = event;
            const newBlocks = [...blocks.map(b => {
                const newB = {...b};
                if (newB.id.length !== 36) {
                    delete newB.id  
                }
                return newB;
            })]
            var result = await actions.createEvent({...event, blocks: newBlocks, reservationEmailTemplate: emailTemplate});
            actions.replace(`/admin/event/${result.response.id}/inventory`);
        } catch (error) {
            this.setState({error: error.message});
        }
    }

    onGarageSelected(id){
        let {event, actions} = this.props;
        if (event.participatingFacilities.findIndex(x => x.facilityId === id)!==-1) {
            event.participatingFacilities = event.participatingFacilities.filter(x => x.facilityId !== id);
        } else {
            event.participatingFacilities = [...event.participatingFacilities, {facilityId: id}];
        }
        actions.updateNewEvent({...event});
    }

    filter(facility) {
        const {distanceFilter} = this.state;
        const {event, venues} = this.props;
        if (event) {
            const venue = venues[event.venueId];
            if (venue) {
                const distance = geo.distance(parseFloat(venue.lat), parseFloat(venue.lng), parseFloat(facility.lat), parseFloat(facility.lng));
                console.log(distance);
                return distance < distanceFilter;
            }
        }
        return true;
    }

    onEditorChange(html) {
        this.setState({emailTemplate: html});
    }

    render() {
        const {error, emailTemplate} = this.state;
        const {facilities, event, venues} = this.props;
        console.log(emailTemplate);
        return (
            <div className='event'>
                <Header as='h1' content="Create New Event" />
                <Form onSubmit={this.onSubmit} error>
                {error ? <Message error content={error}/>:error}
                <Grid>
                    <Grid.Column computer={8} tablet={16} mobile={16}>
                        <Form.Field>
                            <label>{`Event URL: https://reservations.denisonparking.com/${event.slug}`}</label>
                        </Form.Field>
                        <Form.Input name='name' label='Event Name' placeholder='Event Name' value={event.name} onChange={this.onChange} />
                        <Form.Select name='venueId' label='Event Venue' placeholder='Event Venue' value={event.venueId} options={Object.values(venues).map((s, index) => ({text: s.name, value: s.id}))} onChange={this.onChange} />
                        <Form.Input name='contactName' label='Contact Person' placeholder='Contact Person' onChange={this.onChange} />    
                        <Form.Input name='contactEmail' label='Contact Email' placeholder='Contact Email' onChange={this.onChange} />    
                        <Form.Input name='contactPhone' label='Contact Phone' placeholder='Contact Phone' onChange={this.onChange} />
                        <Form.Group>
                        <Form.Field>
                            <label>From</label>
                            <DatePicker
                                name="start"
                                placeholderText="From"
                                selected={event.start || null}
                                onChange={this.onChange}
                                showYearDropdown
                                showMonthDropdown
                                scrollableYearDropdown
                                timeIntervals={15}
                                dateFormat="LL"
                            />
                        </Form.Field>
                        <Form.Field>
                            <label>To</label>
                            <DatePicker
                                name="finish"
                                placeholderText="To"
                                selected={event.finish || null}
                                onChange={this.onChange}
                                showYearDropdown
                                showMonthDropdown
                                scrollableYearDropdown
                                timeIntervals={15}
                                dateFormat="LL"
                            />
                        </Form.Field>
                        </Form.Group>
                        <Form.Field>
                            <label>What to do when they arrive?</label>
                            <TextArea placeholder='Directions' name='directions' value={event.directions} onChange={this.onChange} />
                        </Form.Field>
                    </Grid.Column>
                    <Grid.Column computer={8} tablet={16} mobile={16}>
                        <Table>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell textAlign="center">Participating Facilities</Table.HeaderCell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.HeaderCell><Form.Select label="Distance" defaultValue={.1} selection options={distanceOptions} onChange={this.onDistanceChange} /></Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {Object.values(facilities).filter(this.filter).map((f, index) => (
                                    <Table.Row onClick={() => this.onGarageSelected(f.id)} className={event.participatingFacilities.findIndex(x => x.facilityId === f.id)!==-1 ? 'garage selected' : ''}>
                                        <Table.Cell><div>{f.name}</div></Table.Cell>
                                    </Table.Row>
                                ))}
                            </Table.Body>
                            <Table.Footer>
                                <Table.HeaderCell></Table.HeaderCell>
                            </Table.Footer>
                        </Table>
                        <Segment>
                            <Header as="h3" content="Reservation Blocks" />
                            <p>Reservation blocks are the time periods a parking spot may be reserved, with a rate. This may be a single date or may span consecutive days. Inventory will be allotted and tracked for each block.</p>
                            <div>
                                {event.blocks.map((b, idx) => <InventoryBlock key={idx} block={b} onChange={this.onBlockChange} />)}
                            </div>
                            <Button content="Add Block" type="button" onClick={this.onAddBlock} />
                        </Segment>
                    </Grid.Column>
                </Grid>
                <Header as="h3" content="Email Template" />
                <Editor onChange={this.onEditorChange} fields={emailFields} template={emailTemplate} />
                <Button primary content='Save and Next' />

                </Form>

            </div>
        );
    }
}

CreateEvent.propTypes = {

};

const mapStateToProps = (state, ownProps) => {
    return {
        facilities: Facility.selector(state).facilities,
        event: Events.selector(state).newEvent,
        venues: Venue.selector(state).venue
    }
}

const mapDispatchToProps = (dispatch) => ({
    actions: {
        ...bindActionCreators(Facility.actionCreators, dispatch),
        ...bindActionCreators(Events.actionCreators, dispatch),
        ...bindActionCreators(routerActions, dispatch),
    }
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CreateEvent));